import { createContext, useContext } from 'react';

import { LABEL_TYPE_OPTION } from '../constants.js';
import { LabelTypeOptions } from '../types/pie-chart.config.js';

export type LabelsContextProps = {
  /**
   * Hides the slice labels.
   * @defaultValue false (all the labels are displayed).
   */
  hidden?: boolean;
  /**
   * Display the label with a relative or absolute value.
   * @defaultValue 'relative'
   */
  valueType?: LabelTypeOptions;
};

export const LabelsContext = createContext<LabelsContextProps>({
  hidden: false,
  valueType: LABEL_TYPE_OPTION.Relative,
});

export const useLabels = (): LabelsContextProps => useContext(LabelsContext);
